import { InfoIcon } from 'lucide-react'

import { Banner, Button } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

import { type MemberPurchase } from '../shared/types'

type PurchaseBannerProps = {
  purchase: MemberPurchase;
}

const BannerTitle = ({ purchase, formattedDate }: { purchase: MemberPurchase, formattedDate: string }) => (
  <span className='body'>You purchased <strong className='body-bold inline'>{purchase.variant_name}</strong> on <strong className='body-bold inline'>{formattedDate}</strong></span>
)

export function PurchaseBanner ({ purchase }: PurchaseBannerProps) {
  const { assign } = useWindowLocation()
  const handleViewPurchase = () => {
    assign(`/members/marketplace/orders/${purchase.id}/confirmation`)
  }

  const purchaseDate = new Date(purchase.created_at)
  const formattedDate = purchaseDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  return (
    <Banner
      title={<BannerTitle purchase={purchase} formattedDate={formattedDate} />}
      type='info'
      icon={InfoIcon}
    >
      <Button
        variant='secondary'
        size='small'
        onClick={handleViewPurchase}
      >
        View purchase
      </Button>
    </Banner>
  )
}
